import { Navigate } from 'react-router-dom';
import { useRoutes, BrowserRouter } from 'react-router-dom';
import Login, { StationLogin, AdminLogin } from '../components/auth/Login';
import Logout from '../components/auth/Logout';
import Dashboard from '../components/app/Dashboard';
import Tv from '../components/app/Tv';
import StationStudio from '../components/app/StationStudio';
import { getCurrentTokenClaims } from '../api/Tv';

// Domain detection: riya.console.tv.nanbateam.com vs admin.tv.nanbateam.com
const isConsoleHost = typeof window !== 'undefined' && (
    window.location.hostname.includes('console') || 
    window.location.hostname.includes('station')
);

const App = () => {
    const token = localStorage.getItem('token');
    const auth = !(token === null || token === undefined || token.trim() === '');
    const claims = getCurrentTokenClaims();
    const isClient = claims?.role === 'client' || Boolean(claims?.tv_id);

    // Target route when authenticated
    const authHome = (isConsoleHost || isClient) ? "/station" : "/dashboard";

    return useRoutes([
        {
            path: 'dashboard',
            element: auth 
                ? (isConsoleHost || isClient ? <Navigate to="/station" /> : <Dashboard />) 
                : <Navigate to="/login" />,
        },
        {
            path: '/',
            element: auth 
                ? <Navigate to={authHome} /> 
                : (isConsoleHost ? <StationLogin /> : <Navigate to="/login" />),
            children: [
                { path: '', element: auth ? <Navigate to={authHome} /> : (isConsoleHost ? <StationLogin /> : <Navigate to="/login" />) },
            ],
        },
        {
            path: 'tv',
            element: auth 
                ? (isConsoleHost || isClient ? <Navigate to="/station" /> : <Tv />) 
                : <Navigate to="/login" />,
        },
        {
            path: 'station',
            element: auth ? <StationStudio /> : <Navigate to={isConsoleHost ? "/client/login" : "/login"} />,
        },
        {
            path: 'client',
            element: auth ? <Navigate to="/station" /> : <StationLogin />,
        },
        {
            path: 'client/login',
            element: auth ? <Navigate to="/station" /> : <StationLogin />,
        },
        {
            path: 'station/login',
            element: auth ? <Navigate to="/station" /> : <StationLogin />,
        },
        {
            path: 'admin/login',
            element: auth ? <Navigate to="/dashboard" /> : <AdminLogin />,
        },
        {
            path: 'client/studio',
            element: auth ? <StationStudio /> : <Navigate to="/client/login" />,
        },
        {
            path: 'login',
            element: auth 
                ? <Navigate to={authHome} /> 
                : <Login />,
        },
        {
            path: 'logout',
            element: auth ? <Logout /> : <Navigate to="/login" />,
        },
        {
            path: '*',
            element: auth 
                ? <Navigate to={authHome} /> 
                : <Navigate to="/login" />,
        }
    ]);
};

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
};

export default AppRoutes;
